var _style, _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _rect6, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVElikom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0428\\u0430\\u0440_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFAC3C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    className: "st0",
    width: 1001,
    height: 1001
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 513.3,
    y: 454.02,
    transform: "matrix(0.3816 -0.9243 0.9243 0.3816 -106.2047 775.3065)",
    className: "st1",
    width: 26,
    height: 26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 477.1,
    y: 439.08,
    transform: "matrix(0.3816 -0.9243 0.9243 0.3816 -114.7794 732.6065)",
    className: "st1",
    width: 26,
    height: 26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.37,429.87l-34.31-14.16c-6.14,6.42-11.31,13.77-15.31,21.81l39.7,16.39L470.37,429.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.43,489.4l38.03,15.7c2.76-8.28,4.33-17.1,4.52-26.26l-32.62-13.47L546.43,489.4z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498.36,
    y: 490.22,
    transform: "matrix(0.3816 -0.9243 0.9243 0.3816 -148.9047 783.8829)",
    className: "st1",
    width: 26,
    height: 26
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 462.16,
    y: 475.28,
    transform: "matrix(0.3816 -0.9243 0.9243 0.3816 -157.4803 741.1809)",
    className: "st1",
    width: 26,
    height: 26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.43,466.07l-39.65-16.37c-2.69,8.32-4.18,17.17-4.27,26.36l34,14.03L455.43,466.07z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.49,525.59l32.32,13.34c6.22-6.38,11.48-13.69,15.57-21.7l-37.96-15.67L531.49,525.59z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.15,522.94l-15.94,38.61c8.33,2.66,17.2,4.13,26.4,4.19l13.57-32.88L489.15,522.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.95,508l-13.78,33.38c6.44,6.11,13.8,11.26,21.84,15.23l15.97-38.7L452.95,508z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.66,491.37c2.33,14.31,8.08,27.47,16.38,38.62l11.23-27.21L412.66,491.37z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515.45,564.45c13.54-2.34,26.04-7.75,36.74-15.48l-25.93-10.7L515.45,564.45z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548.67,446.89l13.72-33.24c-6.36-6.24-13.66-11.54-21.67-15.65l-16.09,38.97L548.67,446.89z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.47,431.94l16.13-39.07c-8.27-2.78-17.08-4.38-26.23-4.6l-13.93,33.75L512.47,431.94z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487.16,389.21c-14.52,2.15-27.89,7.81-39.22,16.09l27.83,11.49L487.16,389.21z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M561.75,452.29l26.16,10.8c-2.17-13.75-7.49-26.45-15.2-37.34L561.75,452.29z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580,384c2.89-7.06,6.15-15.04,8-26c1.84-10.88,1.39-19.35,1-26c-0.24-4.07-0.65-8-5-33 c-1.23-7.05-2.27-12.91-3-17c-3.7,2.99-9.56,7.61-17,13c-13.81,10-17.67,11.49-25,18c-3.6,3.2-11.25,10.09-18,21 c-3.79,6.13-7.25,14.84-14,32c-1.77,4.51-3.25,8.36-4.35,11.28c25.94,0.61,49.42,11.13,66.83,27.91 C572.6,399.9,576.41,392.78,580,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M426.53,393.74c1.93,4.44,3.62,8.21,4.9,11.05c17.49-16.67,41.03-27.05,66.99-27.52 c-1.53-5.95-3.87-13.67-7.54-22.43c-2.95-7.04-6.29-14.98-12.73-24.04c-6.39-8.99-12.7-14.67-17.68-19.09 c-3.04-2.71-6.12-5.2-26.87-19.8c-5.85-4.12-10.73-7.52-14.14-9.9c-0.5,4.73-1.38,12.14-2.83,21.21 c-2.69,16.84-4.37,20.61-4.95,30.41c-0.29,4.81-0.82,15.09,2.12,27.58C415.46,368.23,419.17,376.83,426.53,393.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.25,438.25c3.2,3.6,10.09,11.25,21,18c6.13,3.79,14.84,7.25,32,14c4.51,1.77,8.36,3.25,11.28,4.35 c0.61-25.94,11.13-49.42,27.91-66.83c-5.29-3.13-12.41-6.93-21.19-10.52c-7.06-2.89-15.04-6.15-26-8c-10.88-1.84-19.35-1.39-26-1 c-4.07,0.24-8,0.65-33,5c-7.05,1.23-12.91,2.27-17,3c2.99,3.7,7.61,9.56,13,17C328.25,427.06,329.74,430.92,336.25,438.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.88,565.57c4.81,0.29,15.09,0.82,27.58-2.12c7.01-1.65,15.61-5.37,32.53-12.73 c4.44-1.93,8.21-3.62,11.05-4.9c-16.67-17.49-27.05-41.03-27.52-66.99c-5.95,1.53-13.67,3.87-22.43,7.54 c-7.04,2.95-14.98,6.29-24.04,12.73c-8.99,6.39-14.67,12.7-19.09,17.68c-2.71,3.04-5.2,6.12-19.8,26.87 c-4.12,5.85-7.52,10.73-9.9,14.14c4.73,0.5,12.14,1.38,21.21,2.83C343.32,563.31,347.09,564.98,356.88,565.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.5,588c1.77-4.51,3.25-8.36,4.35-11.28c-25.94-0.61-49.42-11.13-66.83-27.91 c-3.13,5.29-6.93,12.41-10.52,21.19c-2.8,6.84-5.94,14.55-7.82,25h78.06C491.6,592.83,492.51,590.52,493.5,588z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.69,592.79c-1.65-7.01-5.37-15.61-12.73-32.53c-1.93-4.44-3.62-8.21-4.9-11.05 c-17.49,16.67-41.03,27.05-66.99,27.52c1.28,4.99,3.15,11.23,5.87,18.27h79.23C587.03,594.27,586.87,593.53,586.69,592.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M682.25,540.75c-10-13.81-11.49-17.67-18-25c-3.2-3.6-10.09-11.25-21-18c-6.13-3.79-14.84-7.25-32-14 c-4.51-1.77-8.36-3.25-11.28-4.35c-0.61,25.94-11.13,49.42-27.91,66.83c5.29,3.13,12.41,6.93,21.19,10.52 c7.06,2.89,15.04,6.15,26,8c10.88,1.84,19.35,1.39,26,1c4.07-0.24,8-0.65,33-5c7.05-1.23,12.91-2.27,17-3 C692.26,554.05,687.64,548.19,682.25,540.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.46,408.18c16.67,17.49,27.05,41.03,27.52,66.99c5.95-1.53,13.67-3.87,22.43-7.54 c7.04-2.95,14.98-6.29,24.04-12.73c8.99-6.39,14.67-12.7,19.09-17.68c2.71-3.04,5.2-6.12,19.8-26.87 c4.12-5.85,7.52-10.73,9.9-14.14c-4.73-0.5-12.14-1.38-21.21-2.83c-16.84-2.69-20.61-4.37-30.41-4.95 c-4.81-0.29-15.09-0.82-27.58,2.12c-7.01,1.65-15.61,5.37-32.53,12.73C579.07,405.22,575.3,406.9,572.46,408.18z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 711,
    className: "st1",
    width: 158,
    height: 7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308,675.82v-37.59h14.66c10.62,0,15.94,2.91,15.94,8.73c0,2.23-0.92,4.15-2.74,5.76 c-1.83,1.61-4.39,2.76-7.67,3.44c8.43,1.43,12.64,4.74,12.64,9.93c0,2.97-1.24,5.29-3.72,6.97c-1.61,1.11-3.43,1.85-5.49,2.21 c-2.05,0.36-5.36,0.54-9.92,0.54H308z M314.98,654.49h2.44c9.4,0,14.09-2.17,14.09-6.5c0-2.13-0.91-3.56-2.73-4.31 c-1.82-0.74-5.34-1.11-10.55-1.11h-3.26V654.49z M314.98,671.48h6.3c4.6,0,7.77-0.39,9.51-1.17c1.74-0.78,2.6-2.22,2.6-4.31 c0-2.42-1.42-4.35-4.27-5.77c-2.85-1.43-6.71-2.14-11.6-2.14h-2.55V671.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.3,675.82v-37.59H398v4.34h-23.73v11.4h20.11v4.34h-20.11v13.18h25.35v4.34H367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M418.74,675.82v-4.34c3.99,0,6.76-0.87,8.3-2.62c1.55-1.75,2.32-4.87,2.32-9.36l0.21-5.68l0.07-4.69v-10.9 h26.95v37.59h-6.98v-33.25h-13v3.57c0,7.34-0.27,12.9-0.8,16.67c-0.53,3.77-1.42,6.46-2.67,8.06 C430.51,674.17,425.7,675.82,418.74,675.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M514.51,675.82h-6.13v-27.11l-20.86,27.11h-6.23v-37.59h6.13v27.08l20.79-27.08h6.3V675.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M548.5,658.65v17.17h-6.98v-37.59h6.98v16.08c2.55,0,4.34-0.24,5.36-0.72c1.03-0.48,2.3-1.67,3.81-3.56 l1.59-1.96l2.02-2.78c2.24-3.07,4.04-5.01,5.38-5.83s3.4-1.23,6.16-1.23h0.81v4.34c-1.49,0-2.63,0.24-3.42,0.73 c-0.79,0.49-1.75,1.53-2.88,3.13c-0.61,0.88-1.05,1.49-1.31,1.85l-1.1,1.44l-1.35,1.85c-1.65,2.17-3.84,3.65-6.55,4.45 c2.17,0.53,3.84,1.2,5.01,2.01c1.17,0.81,2.44,2.17,3.81,4.09l2.05,2.87l2.23,3.05l1.98,2.81l2.8,3.81 c0.17,0.23,0.45,0.62,0.85,1.17h-7.9c-0.33-0.41-0.58-0.71-0.74-0.91l-2.51-3.49l-3.08-4.19c-2.53-3.4-4.2-5.5-5.03-6.31 c-0.83-0.81-2.07-1.57-3.72-2.27H548.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.66,657.01c0-6,1.78-10.78,5.33-14.34c3.56-3.56,8.33-5.35,14.34-5.35c6,0,10.78,1.78,14.34,5.35 c3.56,3.56,5.33,8.34,5.33,14.34c0,6.02-1.78,10.81-5.33,14.37c-3.56,3.56-8.33,5.35-14.34,5.35c-6,0-10.78-1.78-14.34-5.35 C596.44,667.81,594.66,663.02,594.66,657.01z M602.1,657.01c0,4.92,1.06,8.72,3.17,11.38s5.13,4,9.05,4c3.92,0,6.94-1.33,9.07-4 c2.12-2.67,3.19-6.46,3.19-11.38c0-4.9-1.06-8.69-3.19-11.35c-2.12-2.67-5.15-4-9.07-4c-3.92,0-6.93,1.33-9.05,4 S602.1,652.1,602.1,657.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M653.99,675.82v-37.59h8.39l9.99,23.14h0.07l9.81-23.14H691v37.59h-5.7v-32.26h-0.07l-10.23,24.32h-5.88 l-10.2-23.64h-0.07v31.58H653.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVElikom);
export default __webpack_public_path__ + "static/media/vELIKOM.ea7540d59f9bef36d1386eb05262e69c.svg";
export { ForwardRef as ReactComponent };